// extracted by mini-css-extract-plugin
export default {"imageWrapper":"bJ-z","hovered":"cJ-z","hoverImage":"dJ-z","mainImage":"eJ-z","imageNoBackground":"fJ-z","fullSizeImage":"gJ-z"};